module.exports = __webpack_public_path__ + "img/4_124.38a77c55.png";